<template>
    <el-dialog
            :visible="isVisible"
            @close="hide"
            :title="title"
            :destroy-on-close="true"
    >
        <loading v-if="!isInitialized"></loading>
        <provider-form v-if="isInitialized" v-bind="formData" @stored="onStored"></provider-form>
    </el-dialog>
</template>

<script>
  import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
  import ProviderForm from '../../components/provider/form';
  import Loading from '../../components/loading';
  import eventBus from '../../event-bus';

  export default {
    extends: BaseDialogFormWrapper,

    components: {
      Loading,
      ProviderForm,
    },

    computed: {
      /**
       * @return {boolean}
       */
      modelExists() {
        return _.has(this.formData, 'model.id');
      },

      /**
       * @return {string}
       */
      title() {
        if (!this.isInitialized) {
          return 'Loading ...';
        } else if (this.modelExists) {
          return 'Edit Provider';
        }

        return 'Create Provider';
      },
    },

    methods: {
      /**
       * @param {string|undefined} message
       */
      onStored({message}) {
        _.isString(message) && this.$message.success(message);
        this.hide();
        eventBus.$emit('refresh-provider-table');
      },
    },

    created() {
      eventBus.$on('show-provider-form-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-provider-form-dialog', this.show);
    }
  }
</script>
